import { cn } from '@dashai/lib/utils';

// The bar's side padding. The pages under it take the same inset, so their
// edges line up with the wordmark and the account menu.
export const TOP_BAR_SIDE_INSET = '48px';

// Entries in the navy bar, styled like DashLeads' top navigation: text in the
// bar's foreground, a light fill on hover or while a panel is open, and a
// brighter fill on the section the user is in.
export function navPillClass(active?: boolean) {
  return cn(
    'inline-flex h-10 items-center gap-2 rounded-lg px-3 text-sm font-bold transition-colors outline-none focus-visible:ring-2 focus-visible:ring-topbar-foreground/40',
    active
      ? 'bg-topbar-foreground/15 text-topbar-foreground hover:bg-topbar-foreground/15 hover:text-topbar-foreground data-[state=open]:bg-topbar-foreground/15'
      : 'bg-transparent text-topbar-foreground/80 hover:bg-topbar-foreground/10 hover:text-topbar-foreground data-[state=open]:bg-topbar-foreground/10 data-[state=open]:text-topbar-foreground'
  );
}
